import React from 'react';
import {useTranslation} from "react-i18next";
import BackIcon from "@mui/icons-material/North";
import {AssetBoxContainer, AssetBoxWrapper, AssetLabel} from "./AssetBoxStyle";


interface AssetBoxBackProps {
    handleBackClick: () => void;
}

const AssetBoxBack: React.FC<AssetBoxBackProps> = ({
                                                       handleBackClick
                                                   }) => {
    const {t} = useTranslation();

    return (
        <AssetBoxContainer
            item
            xs={4}
            md={3}>
            <AssetBoxWrapper
                onClick={handleBackClick}>
                <BackIcon
                    sx={{
                        width: "36px",
                        height: "36px",
                        display: "block",
                        objectFit: "contain",
                        margin: "auto",
                        color: "black"
                    }}
                />
            </AssetBoxWrapper>
            <AssetLabel>
                {t("editor.select.back")}
            </AssetLabel>
        </AssetBoxContainer>
    );
};

export default AssetBoxBack;
